// I guess this export is deprecated.
export { default } from '../modules/cache.js'